export const TARGET_CPA_LEARNING_STATES = {
    NEW: 'NEW',
    CVR_LEARNING: 'CVR_LEARNING',
    CVR_LEARNING_LIMITED: 'CVR_LEARNING_LIMITED',
    TCPA_LEARNING: 'TCPA_LEARNING',
    LEARNING_COMPLETED: 'LEARNING_COMPLETED',
};
